import { marketingBannerHeightPx } from 'core/layouts/ui-blocks/ReusableStyles';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const GraphicLeft = 'https://baseavaar2.s3.amazonaws.com/campaign_asset1.webp';
export const GraphicRight = 'https://baseavaar2.s3.amazonaws.com/campaign_asset_2.webp';

export const BannerText =
	'https://redernet-image-data.s3.amazonaws.com/prod/assets/homepage/leap_day_offer_strip.webp';

export const BannerBg = 'https://baseavaar2.s3.amazonaws.com/campaign_asset_entrypoint_bg.webp';

export const marketingBannerStyles = {
	fixedMarketingBannerAnimationWrapper: {
		transition: 'height 0.5s ease',
		overflow: 'hidden',
	},
	fixedMarketingBannerWrapper: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,

		backgroundColor: 'colors.dark6',

		zIndex: 1008,
	},

	MarketingBannerCont: {
		height: marketingBannerHeightPx,
		width: '100%',

		transition: 'height 0.5s ease',
		overflow: 'hidden',
	},
	MarketingBanner: {
		height: marketingBannerHeightPx,
		width: '100%',

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',

		cursor: 'pointer',

		'& img': {
			height: '100%',
			width: 'auto',
		},
	},
	closeButton: {
		minWidth: 'unset',
		padding: '0 13px',

		display: 'flex',
		alignItems: 'center',

		'& svg': {
			height: '24px',
			width: 'auto',
			stroke: `${colorPalette.light3}`,
		},
	},
};
